/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import { EntityType, IGenericDetailedReportRequestObject } from 'interfaces';
import { httpLegend } from 'services/http.legend';
import { InteractionInputDTO, ICustomizedLegendData } from '../CustomizedReportInterfaces';
import { ILegendDataHelper } from '../CustomizedReportHelper';

export class ParametricWaferMapLegendDataHelper implements ILegendDataHelper {
  private legendData : any = undefined;

  preferences = {
    summary: {
      calculateCustomSummary: (options:any) => {
        if (this.legendData.legendSummary.length > 0 && this.legendData.legendSummary[0][0][options.name]) {
          options.totalValue = this.legendData.legendSummary[0][0][options.name];
        }
      },
      totalItems: [
        // with grouping applied
        {
          column: 'Average die_x',
          name: 'Average die_x',
          summaryType: 'custom',
          displayFormat: 'Average die_x: {0}',
          showInColumn: 'die_x',
          showInGroupFooter: true,
        },
        {
          column: 'Average die_y',
          name: 'Average die_y',
          summaryType: 'custom',
          displayFormat: 'Average die_y: {0}',
          showInColumn: 'die_y',
          showInGroupFooter: true,
        },

        // with or without grouping applied
        {
          name: 'Combined Total Dies',
          summaryType: 'custom',
          displayFormat: 'Combined Total Dies: {0}',
          showInColumn: 'Total Dies',
          showInGroupFooter: true,
        },
      ],
    },
    legendKeyExpression: 'die_id',
    selectionEventDefaults: {
      xAxisLabel: 'DIE_ID', // TO DO: YET TO DECIDE 💀
      yAxisLabel: 'CLASS_NAME', // TO DO: YET TO DECIDE 💀
      avoidXWhenGroupingPresent: false,
    },
    defaultGrouping: {
      groupKey: 'wafer_key', // TO DO: YET TO DECIDE 💀
      entityType: ('WAFER' as EntityType), // TO DO: YET TO DECIDE 💀
      columnName: 'key', // TO DO: YET TO DECIDE 💀
    },
    postSelectionInYAxis: true,
    equalNumberOfYsForX: true,
  };

  setLegendData = (data: ICustomizedLegendData) => {
    this.legendData = data;
  };

  getPreferences = () => (this.preferences);

  postCombinedEvent = (selectionEventInput: InteractionInputDTO) => {
    return httpLegend.setInteractionData(selectionEventInput);
  };

  getDetailedGraphLegendData = async (requestObject: IGenericDetailedReportRequestObject, callback: (legendData: ICustomizedLegendData) => void) => {
    const data = await httpLegend.getLegend(requestObject);
    this.setLegendData(data);
    callback(data);
  };

  subscribeSelectionEvent = async (requestObject: IGenericDetailedReportRequestObject, callback: (graphData: ICustomizedLegendData) => void) => {
    const data = await httpLegend.getLegend(requestObject);
    this.setLegendData(data);
    callback(data);
  };

  subscribeHidingEvent = async (requestObject: IGenericDetailedReportRequestObject, callback: (graphData: ICustomizedLegendData) => void) => {
    const data = await httpLegend.getLegend(requestObject);
    this.setLegendData(data);
    callback(data);
  };
}
